var _path, _path2;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var SvgPermissions = function SvgPermissions(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 22,
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0 0h22v22H0z",
    fill: "none"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M11 1.5a9.5 9.5 0 1 1 0 19 9.5 9.5 0 0 1 0-19zm0 1.129a8.371 8.371 0 1 0 0 16.742A8.371 8.371 0 0 0 11 2.63zm0 3.01c1.237 0 2.268.92 2.425 2.128l.015.16.006.157v1.317h.376c.685 0 1.27.461 1.449 1.1l.03.13.019.135.007.14v3.762a1.508 1.508 0 0 1-1.23 1.48l-.135.019-.14.006H8.178a1.507 1.507 0 0 1-1.479-1.23l-.019-.134-.007-.14v-3.763a1.51 1.51 0 0 1 1.23-1.48l.135-.018.14-.007h.376V8.084c0-1.244.93-2.272 2.133-2.426l.158-.015L11 5.64zm2.822 4.89H8.178a.379.379 0 0 0-.348.231l-.02.07-.008.076v3.762c0 .157.096.293.23.349l.07.02.076.008h5.644a.379.379 0 0 0 .348-.23l.02-.07.008-.077v-3.762a.377.377 0 0 0-.376-.376zM11 6.768c-.638 0-1.175.455-1.293 1.062l-.017.124-.007.131v1.317h2.634V8.084c0-.684-.522-1.247-1.19-1.31L11 6.766z"
  })));
};

export default SvgPermissions;